import { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import { Sort, Filter, Result, DomainObject } from 'types';

interface FetchListHookProps<TObject> {
  fetchList: (
    sort?: Sort[],
    filters?: Filter[],
    size?: number
  ) => Promise<Result<TObject>>;

  withRedirect?: boolean;
}

export function useFetchList<TObject extends DomainObject>({
  fetchList,
  withRedirect,
}: FetchListHookProps<TObject>) {
  const [items, setItems] = useState<TObject[]>([]);

  const { id } = useParams<{ id: string; level: string }>();
  const history = useHistory();
  const location = useLocation();

  const getData = useCallback(async () => {
    try {
      const response = await fetchList();

      setItems(response.items!);

      if (withRedirect && !id && response.items!.length) {
        history.replace(`${location.pathname}/0/${response.items![0].id}`);
      }
    } catch (e) {
      console.log(e);

      setItems([]);
    }
  }, [fetchList, history, id, location.pathname, withRedirect]);

  useEffect(() => {
    if (!id || items.length === 0) {
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return { items, refreshList: getData };
}
